import { render, staticRenderFns } from "./WelcomeMessageStep.vue?vue&type=template&id=627800c9"
import script from "./WelcomeMessageStep.vue?vue&type=script&lang=js"
export * from "./WelcomeMessageStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports